import { render, staticRenderFns } from "./TtnResponses.vue?vue&type=template&id=06a142b7&"
import script from "./TtnResponses.vue?vue&type=script&lang=js&"
export * from "./TtnResponses.vue?vue&type=script&lang=js&"
import style0 from "./TtnResponses.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports